import React from 'react';
import styles from './index.module.less';
import { isDrFans } from '@/shared/app-common';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import copy from 'clipboard-copy';
import { message } from 'antd';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SharePage = ({ shareUrl }: { shareUrl: string }) => {
  const { t } = useTranslation('common');
  const twPath = isDrFans ? '/images/share/share_twitter_blank.png' : '/images/share/share_twitter.png';
  const copyPath = isDrFans ? '/images/share/share_copy.png' : '/images/share/share_copy_blank.png';

  const title = `Loving this! 🌟 Can't believe I didn't find this sooner.`;

  const handleCopyAction = async () => {
    try {
      await copy(shareUrl);
      message.success(t('URLCopiedToClipboard'));
    } catch {
      message.error('Unable to copy text to clipboard:');
    }
  };

  return (
    <div className={styles.container}>
      <span>{t('share')}</span>

      <FacebookShareButton url={shareUrl}>
        <div className={styles.imgItem}>
          <Image
            src="/images/share/share_fb.png"
            alt="Facebook Share"
            loading="lazy"
            width={28}
            height={28}
            layout="responsive"
          />
        </div>
      </FacebookShareButton>

      <TwitterShareButton title={title} url={shareUrl}>
        <div className={styles.imgItem}>
          <Image src={twPath} alt="Twitter Share" loading="lazy" width={28} height={28} layout="responsive" />
        </div>
      </TwitterShareButton>

      <div className={styles.imgItem}>
        <Image
          src={copyPath}
          alt="Copy"
          loading="lazy"
          width={28}
          height={28}
          layout="responsive"
          onClick={handleCopyAction}
        />
      </div>
    </div>
  );
};

export default SharePage;
